import React, { useContext } from "react";
import { ListActionButtonProps } from "sprint-common-web";

import { ViewAssetButton } from "../../../../../common/components/ViewAssetButton";
import { TvSeriesContext } from "../../../context/TvSeriesContext";

export const ViewSeasonAssetButton: React.FunctionComponent<ListActionButtonProps> = (props: ListActionButtonProps) => {
    const tvSeriesContext = useContext(TvSeriesContext);

    const handleClick = () => {
        tvSeriesContext.moveToTvSeriesAssets(props.itemId);
    };

    return <ViewAssetButton disabled={props.disabled} onClick={handleClick} />;
};
